'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Button } from '@/components/ui/Button';
import { Logo } from '@/components/ui/Logo';
import { Locale } from '@/lib/i18n';
import { cn } from '@/hooks/utils';
import { LanguageSwitcher } from './LanguageSwitcher';
import { ROUTES } from '@/constants';
import { MobileMenu } from './MobileMenu';
import { useEnv } from '@/components/providers/EnvProvider';
import { useThemeSync } from '@/hooks/useThemeSync';
export const Navbar = t0 => {
  const $ = _c(84);
  const {
    lang,
    dict,
    isDarkProp
  } = t0;
  const pathname = usePathname();
  const {
    isDark: sessionIsDark
  } = useThemeSync();
  const {
    DEMO_LINK,
    PRACTICE_LOGIN_URL
  } = useEnv();
  const [isDark, setIsDark] = React.useState(isDarkProp ?? true);
  const [isScrolled, setIsScrolled] = React.useState(false);
  let t1;
  let t2;
  if ($[0] !== sessionIsDark) {
    t1 = () => {
      setIsDark(sessionIsDark);
    };
    t2 = [sessionIsDark];
    $[0] = sessionIsDark;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  React.useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const handleScroll = () => {
        setIsScrolled(window.scrollY > 20);
        const x = window.innerWidth / 2;
        const element = document.elementFromPoint(x, 80);
        const section = element?.closest("[data-theme]");
        if (section) {
          const theme = section.getAttribute("data-theme");
          setIsDark(theme === "dark");
        } else {
          setIsDark(true);
        }
      };
      window.addEventListener("scroll", handleScroll);
      handleScroll();
      return () => window.removeEventListener("scroll", handleScroll);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== pathname || $[5] !== sessionIsDark) {
    t4 = [pathname, sessionIsDark];
    $[4] = pathname;
    $[5] = sessionIsDark;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  React.useEffect(t3, t4);
  const t5 = `/${lang}${ROUTES.PRODUCTS}`;
  let t6;
  if ($[7] !== dict.common.products || $[8] !== t5) {
    t6 = {
      name: dict.common.products,
      href: t5
    };
    $[7] = dict.common.products;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = `/${lang}${ROUTES.INITIATIVES}`;
  let t8;
  if ($[10] !== dict.common.initiatives || $[11] !== t7) {
    t8 = {
      name: dict.common.initiatives,
      href: t7
    };
    $[10] = dict.common.initiatives;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t6 || $[14] !== t8) {
    t9 = [t6, t8];
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const navLinks = t9;
  let t10;
  if ($[16] !== pathname) {
    t10 = (e, href) => {
      const normalizedPathname = pathname?.replace(/\/$/, "") || "";
      const normalizedHref = href.replace(/\/$/, "");
      if (normalizedPathname === normalizedHref) {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
    };
    $[16] = pathname;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const handleLinkClick = t10;
  const t11 = isScrolled ? isDark ? "nav-scrolled-dark" : "nav-scrolled-light" : "border-b border-transparent bg-transparent";
  let t12;
  if ($[18] !== t11) {
    t12 = cn("fixed top-0 z-50 w-full bg-transparent py-2 sm:py-3", t11);
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const t13 = `/${lang}`;
  let t14;
  if ($[20] !== handleLinkClick || $[21] !== lang) {
    t14 = e_0 => handleLinkClick(e_0, `/${lang}`);
    $[20] = handleLinkClick;
    $[21] = lang;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  const t15 = isDark ? "white" : "#0b0623";
  let t16;
  let t17;
  let t18;
  let t19;
  let t20;
  let t21;
  let t22;
  let t23;
  let t24;
  let t25;
  let t26;
  let t27;
  let t28;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <path d="M52.3582 20.399C51.9811 19.8279 51.5076 19.4021 50.9434 19.1295C50.3766 18.8543 49.7679 18.6804 49.1153 18.6103C48.4624 18.5402 47.8539 18.5038 47.2868 18.5038V18.1975C47.7421 18.1975 48.2258 18.1508 48.7382 18.0573C49.2479 17.9638 49.7158 17.7873 50.1397 17.5277C50.5663 17.2681 50.9147 16.9046 51.1905 16.4321C51.466 15.9622 51.6039 15.3418 51.6039 14.5733C51.6039 13.9606 51.5076 13.4025 51.3205 12.9014C51.1305 12.3978 50.8237 11.9694 50.4 11.6163C49.9761 11.2633 49.4247 10.9907 48.7484 10.7934C48.0724 10.5961 47.2324 10.5 46.2258 10.5H40V26.9725H47.7108C48.5274 26.9725 49.2608 26.8788 49.9058 26.6919C50.5482 26.5025 51.0968 26.2247 51.5442 25.856C51.9916 25.4874 52.3347 25.0383 52.5713 24.5138C52.8055 23.9868 52.925 23.3871 52.925 22.7121C52.925 21.7386 52.7353 20.9649 52.3582 20.3912V20.399ZM43.1416 13.187H45.9216C46.2832 13.187 46.6161 13.2181 46.9229 13.2804C47.2297 13.3428 47.5029 13.444 47.7368 13.5868C47.9734 13.727 48.1529 13.9243 48.2803 14.1735C48.4053 14.4253 48.4676 14.7473 48.4676 15.1393C48.4676 15.4846 48.4103 15.7805 48.2908 16.0219C48.1737 16.266 47.9995 16.4711 47.7732 16.6346C47.5445 16.8008 47.2739 16.9176 46.9592 16.9877C46.6445 17.0578 46.2987 17.0941 45.9216 17.0941H43.1416V13.187ZM49.5624 23.1639C49.4142 23.4468 49.2063 23.6701 48.9384 23.8363C48.6705 23.9998 48.3429 24.1166 47.9579 24.1893C47.5729 24.2594 47.1516 24.2932 46.6966 24.2932H43.1389V19.7759H46.5092C46.9176 19.7759 47.3208 19.8071 47.7239 19.8694C48.1242 19.9343 48.4729 20.0511 48.7718 20.2225C49.0711 20.3964 49.3155 20.6327 49.5026 20.9286C49.6924 21.2272 49.7861 21.6218 49.7861 22.1072C49.7861 22.5304 49.7134 22.8835 49.5624 23.1664V23.1639Z" />;
    t17 = <path d="M62.834 22.62C62.6288 23.1366 62.2985 23.5754 61.8433 23.9388C61.3883 24.2997 60.7822 24.4788 60.028 24.4788C59.4767 24.4788 59.0164 24.3957 58.6472 24.2322C58.278 24.066 57.9709 23.835 57.7264 23.5364C57.4846 23.2405 57.3027 22.877 57.1856 22.4538C57.1101 22.1891 57.0609 21.9061 57.0322 21.6049L65.258 21.5348V20.5717C65.258 19.5826 65.1254 18.7336 64.8575 18.0275C64.5896 17.3213 64.2177 16.7372 63.7367 16.2725C63.258 15.8104 62.6783 15.4703 62.0046 15.2496C61.3259 15.0289 60.5872 14.9199 59.7862 14.9199C58.7798 14.9199 57.9059 15.0731 57.1675 15.3794C56.4288 15.6858 55.8151 16.1089 55.3288 16.6489C54.8398 17.1915 54.4783 17.8379 54.2443 18.5934C54.0077 19.3463 53.8906 20.1615 53.8906 21.0416C53.8906 21.9216 54.0104 22.7368 54.2546 23.4897C54.499 24.2426 54.8712 24.8916 55.3756 25.4316C55.8775 25.9742 56.5043 26.3974 57.2506 26.7037C57.9969 27.01 58.8812 27.1632 59.9033 27.1632C61.2401 27.1632 62.3817 26.8777 63.3204 26.3039C64.2646 25.7302 64.9406 24.9435 65.349 23.9388L62.829 22.62H62.834ZM57.6822 18.4662C57.9112 18.1443 58.2051 17.8925 58.5664 17.7133C58.928 17.5316 59.378 17.4407 59.9112 17.4407C60.6185 17.4407 61.1775 17.6329 61.5859 18.0171C61.994 18.4039 62.1996 18.9024 62.1996 19.5124H57.2038C57.313 19.1127 57.4743 18.7648 57.6848 18.4662H57.6822Z" />;
    t18 = <path d="M75.285 18.1236C74.2629 18.1236 73.3916 18.2612 72.6687 18.5364C71.9458 18.8116 71.3527 19.188 70.8898 19.6657C70.4269 20.1434 70.089 20.7119 69.8756 21.3714C69.6624 22.0308 69.5585 22.7447 69.5585 23.5131V26.9243H66.4453V15.1562H69.5585V17.6278C69.5585 18.0821 69.4908 18.4429 69.3582 18.7103C69.2256 18.9778 69.0798 19.2192 68.9211 19.4399L69.1814 19.6034C69.4493 19.2581 69.7145 18.8298 69.9822 18.3209C70.25 17.8121 70.5961 17.3214 71.02 16.8489C71.4437 16.379 71.9951 15.9792 72.6714 15.6495C73.3474 15.3198 74.2187 15.1562 75.2877 15.1562V18.121L75.285 18.1236Z" />;
    t19 = <path d="M85.1129 18.1236C84.0908 18.1236 83.2198 18.2612 82.4966 18.5364C81.7737 18.8116 81.1808 19.188 80.7179 19.6657C80.255 20.1434 79.9169 20.7119 79.7037 21.3714C79.4903 22.0308 79.3863 22.7447 79.3863 23.5131V26.9243H76.2734V15.1562H79.3863V17.6278C79.3863 18.0821 79.3187 18.4429 79.1861 18.7103C79.0534 18.9778 78.9079 19.2192 78.7492 19.4399L79.0092 19.6034C79.2771 19.2581 79.5424 18.8298 79.8103 18.3209C80.0782 17.8121 80.424 17.3214 80.8479 16.8489C81.2719 16.379 81.8232 15.9792 82.4992 15.6495C83.1755 15.3198 84.0466 15.1562 85.1155 15.1562V18.121L85.1129 18.1236Z" />;
    t20 = <path d="M96.7331 26.7609C96.7331 28.8325 95.5731 31.8338 90.5279 31.8338C89.4902 31.8338 88.3355 31.6209 87.4384 31.3872L88.0131 28.7391C88.8142 28.9285 89.7816 29.0922 90.7724 29.0922C93.1545 29.0922 93.6252 27.8693 93.6252 26.6206C93.6252 25.372 94.0492 24.1492 94.616 23.0199L94.2623 22.807C94.2623 22.807 92.9413 27.0672 89.8076 27.0672C87.3787 27.0672 86.1016 25.2551 86.1016 22.9965V15.1589H89.2174V22.5007C89.2174 23.8662 90.065 24.4763 91.0324 24.4763C92.2339 24.4763 93.6252 23.4872 93.6252 21.8646V15.1562H96.7331V26.7609Z" />;
    t21 = <path d="M97.9869 15.2056C97.9869 14.515 98.109 13.8712 98.3535 13.2767C98.598 12.6796 98.983 12.15 99.5083 11.6878C100.034 11.2257 100.723 10.8649 101.571 10.6052C102.419 10.3456 103.44 10.2158 104.634 10.2158C105.042 10.2158 105.487 10.2392 105.966 10.2859C106.444 10.3327 106.928 10.4261 107.417 10.5689C107.903 10.7091 108.371 10.9012 108.819 11.1452C109.266 11.3893 109.666 11.7112 110.02 12.111C110.374 12.5108 110.652 12.9911 110.857 13.5467C111.06 14.1048 111.164 14.7746 111.164 15.5586V16.0986H108.051V15.5586C108.051 15.1511 107.981 14.7824 107.838 14.4527C107.698 14.123 107.487 13.8452 107.214 13.6167C106.938 13.3909 106.585 13.2143 106.153 13.0871C105.721 12.9625 105.214 12.8976 104.632 12.8976C103.877 12.8976 103.269 12.9755 102.803 13.1339C102.34 13.2896 101.981 13.4921 101.732 13.7336C101.48 13.9776 101.316 14.232 101.238 14.4994C101.16 14.7668 101.121 15.0031 101.121 15.2056C101.121 15.5508 101.212 15.8338 101.391 16.0519C101.571 16.2726 101.82 16.4517 102.135 16.5919C102.45 16.7321 102.827 16.8437 103.266 16.9216C103.706 16.9995 104.169 17.0852 104.657 17.1812C105.427 17.3058 106.221 17.4564 107.04 17.6277C107.856 17.8017 108.6 18.0639 109.269 18.417C109.937 18.77 110.483 19.24 110.907 19.8293C111.331 20.4186 111.544 21.1974 111.544 22.171C111.544 22.8615 111.414 23.5053 111.154 24.0999C110.894 24.697 110.491 25.2266 109.939 25.6887C109.388 26.1508 108.681 26.5117 107.817 26.7712C106.954 27.0309 105.916 27.1606 104.704 27.1606C104.312 27.1606 103.867 27.1372 103.373 27.0906C102.879 27.0438 102.379 26.9504 101.875 26.8077C101.373 26.6675 100.881 26.4754 100.4 26.2313C99.9219 25.9872 99.4927 25.6653 99.1156 25.2655C98.7385 24.8657 98.4396 24.388 98.2209 23.8299C97.9998 23.2743 97.8906 22.6019 97.8906 21.8179V21.2779H101.004V21.8179C101.004 22.2255 101.087 22.5941 101.251 22.9238C101.415 23.2535 101.659 23.5365 101.981 23.7702C102.304 24.0064 102.691 24.183 103.149 24.2998C103.604 24.4166 104.124 24.4763 104.704 24.4763C105.521 24.4763 106.174 24.3984 106.66 24.2401C107.146 24.0843 107.521 23.8844 107.781 23.6403C108.041 23.3963 108.213 23.1419 108.299 22.8745C108.384 22.6071 108.429 22.3735 108.429 22.1683C108.429 21.7452 108.311 21.4025 108.075 21.1455C107.838 20.8859 107.524 20.6756 107.131 20.5095C106.738 20.3459 106.278 20.2083 105.752 20.0967C105.225 19.9876 104.663 19.8838 104.067 19.7903C103.344 19.6657 102.616 19.5151 101.885 19.3438C101.155 19.1724 100.499 18.9206 99.9167 18.5909C99.334 18.2612 98.8685 17.8302 98.5148 17.2955C98.1612 16.7632 97.9843 16.0649 97.9843 15.2004L97.9869 15.2056Z" />;
    t22 = <path d="M117.514 17.8405V22.2279C117.529 22.6459 117.571 22.9808 117.638 23.2353C117.703 23.4897 117.813 23.7129 117.964 23.9077C118.083 24.0426 118.239 24.1465 118.434 24.2218C118.63 24.297 118.853 24.3334 119.108 24.3334H121.186V26.9321H118.257C117.719 26.9321 117.199 26.8542 116.697 26.6958C116.195 26.54 115.758 26.2753 115.384 25.9015C114.981 25.4991 114.692 25.0084 114.52 24.4347C114.349 23.8583 114.263 23.1989 114.263 22.4512V17.8405H112.297V15.1613H114.396V11.9136H117.506V15.1613H121.183V17.8405H117.514Z" />;
    t23 = <path d="M125.522 21.797C125.522 22.2668 125.574 22.6485 125.675 22.9392C125.777 23.23 125.912 23.4559 126.076 23.622C126.24 23.7856 126.43 23.8998 126.643 23.9621C126.856 24.0244 127.056 24.0556 127.244 24.0556C127.777 24.0556 128.242 23.9232 128.635 23.6558C129.027 23.3884 129.35 23.0509 129.602 22.6433C129.855 22.2357 130.042 21.7762 130.169 21.2673C130.294 20.7585 130.359 20.2756 130.359 19.8187V15.1587H133.472V26.9268H130.359V25.5146C130.359 24.8085 130.421 24.2944 130.549 23.9725C130.674 23.6506 130.817 23.3884 130.973 23.1833L130.736 22.9704C130.468 23.3157 130.214 23.7285 129.969 24.2062C129.725 24.6838 129.433 25.1433 129.098 25.5821C128.76 26.0208 128.336 26.3947 127.824 26.701C127.314 27.0073 126.671 27.1605 125.902 27.1605C125.525 27.1605 125.132 27.1165 124.724 27.0307C124.315 26.945 123.938 26.7634 123.592 26.4907C123.246 26.2156 122.963 25.8209 122.745 25.3017C122.524 24.7825 122.414 24.0945 122.414 23.23V15.1587H125.527V21.7943L125.522 21.797Z" />;
    t24 = <path d="M147.332 26.9268H144.195V26.2675C144.195 25.7664 144.25 25.3251 144.359 24.9486C144.468 24.5722 144.572 24.2503 144.666 23.9829L144.382 23.8193C144.177 24.4787 143.919 25.0265 143.605 25.4679C143.29 25.9066 142.942 26.2493 142.557 26.4907C142.172 26.7347 141.764 26.906 141.332 27.0073C140.9 27.1086 140.463 27.1605 140.024 27.1605C139.111 27.1605 138.315 27.0073 137.631 26.701C136.947 26.3947 136.372 25.9715 135.909 25.4289C135.447 24.8889 135.101 24.2399 134.872 23.487C134.643 22.7341 134.531 21.919 134.531 21.0389C134.531 20.1588 134.645 19.3488 134.872 18.6037C135.101 17.8586 135.447 17.2122 135.909 16.6618C136.372 16.1114 136.947 15.6857 137.631 15.3793C138.315 15.073 139.113 14.9198 140.024 14.9198C140.463 14.9198 140.9 14.9718 141.332 15.073C141.764 15.1743 142.172 15.3508 142.557 15.6026C142.942 15.8544 143.29 16.1945 143.605 16.6255C143.919 17.0564 144.179 17.6094 144.382 18.2844L144.666 18.0949C144.572 17.8275 144.468 17.5056 144.359 17.1291C144.25 16.7527 144.195 16.3061 144.195 15.7869V9.26807H147.332V26.9268ZM144.172 20.5716C144.172 20.2263 144.117 19.8706 144.008 19.502C143.899 19.1333 143.714 18.8036 143.454 18.5129C143.194 18.2221 142.853 17.9833 142.429 17.7963C142.005 17.6068 141.485 17.5133 140.874 17.5133C140.466 17.5133 140.068 17.5756 139.683 17.7029C139.298 17.8275 138.955 18.0352 138.658 18.3259C138.359 18.6167 138.12 18.9854 137.938 19.4319C137.756 19.8784 137.668 20.4158 137.668 21.0441C137.668 21.6723 137.759 22.2331 137.938 22.6796C138.117 23.1261 138.359 23.4922 138.658 23.7752C138.957 24.0581 139.298 24.2659 139.683 24.3983C140.068 24.5306 140.466 24.5981 140.874 24.5981C141.488 24.5981 142.005 24.4995 142.429 24.3048C142.853 24.1101 143.197 23.866 143.454 23.5753C143.714 23.2845 143.899 22.96 144.008 22.5991C144.117 22.2383 144.172 21.8852 144.172 21.5399V20.5716Z" />;
    t25 = <path d="M150.204 10.4521C151.062 10.4521 151.759 11.1479 151.759 12.0046C151.759 12.8613 151.062 13.5571 150.204 13.5571C149.345 13.5571 148.648 12.8613 148.648 12.0046C148.648 11.1479 149.345 10.4521 150.204 10.4521ZM148.648 15.1589H151.761V26.927H148.648V15.1589Z" />;
    t26 = <path d="M153.033 18.5959C153.285 17.843 153.665 17.1966 154.178 16.654C154.687 16.114 155.322 15.6882 156.076 15.3819C156.83 15.0755 157.717 14.9224 158.739 14.9224C159.761 14.9224 160.624 15.0755 161.379 15.3819C162.133 15.6882 162.765 16.1114 163.277 16.654C163.787 17.194 164.169 17.843 164.422 18.5959C164.674 19.3488 164.799 20.1639 164.799 21.044C164.799 21.9241 164.674 22.7393 164.422 23.4922C164.169 24.245 163.789 24.8915 163.277 25.434C162.768 25.9767 162.133 26.3999 161.379 26.7062C160.624 27.0125 159.743 27.1657 158.739 27.1657C157.735 27.1657 156.83 27.0125 156.076 26.7062C155.322 26.3999 154.69 25.9767 154.178 25.434C153.668 24.8941 153.285 24.245 153.033 23.4922C152.781 22.7393 152.656 21.9241 152.656 21.044C152.656 20.1639 152.781 19.3488 153.033 18.5959ZM155.957 22.4433C156.081 22.8743 156.263 23.2403 156.497 23.5389C156.734 23.8374 157.036 24.0685 157.405 24.232C157.774 24.3956 158.211 24.4787 158.713 24.4787C159.215 24.4787 159.657 24.3956 160.034 24.232C160.411 24.0685 160.718 23.8348 160.955 23.5389C161.192 23.2403 161.368 22.8795 161.485 22.4563C161.602 22.0332 161.662 21.5632 161.662 21.044C161.662 20.5248 161.602 20.0757 161.485 19.6447C161.368 19.2138 161.192 18.8477 160.955 18.5517C160.718 18.2532 160.414 18.0221 160.034 17.8586C159.654 17.695 159.218 17.6119 158.713 17.6119C158.209 17.6119 157.774 17.695 157.405 17.8586C157.036 18.0221 156.734 18.2558 156.497 18.5517C156.261 18.8503 156.081 19.2112 155.957 19.6343C155.832 20.0575 155.767 20.5274 155.767 21.0466C155.767 21.5658 155.829 22.015 155.957 22.4459V22.4433Z" />;
    t27 = <path d="M24.8756 2.3391C24.6337 3.90455 23.7287 5.29347 22.4024 6.158C21.4298 6.79405 20.3401 7.07961 19.2244 7.35479C18.0801 7.63258 16.9307 7.86624 15.7916 8.14142C15.763 8.10508 15.7344 7.87663 15.7136 7.64555C15.6902 7.41711 15.672 7.18605 15.6694 7.15229C15.6356 6.69797 15.6382 6.25405 15.711 5.80232C15.9502 4.23426 16.8579 2.84795 18.1816 1.98343C19.1568 1.34738 20.2465 1.06181 21.3596 0.786624C22.5038 0.508839 23.6663 0.246631 24.795 0C24.808 0.0441339 24.8366 0.275189 24.8626 0.50105C24.886 0.729508 24.912 0.952774 24.9146 0.989121C24.951 1.44344 24.9458 1.88738 24.8756 2.3391Z" fill="url(#paint0_linear_1112_31)" />;
    t28 = <path d="M30.7187 11.0488C28.8279 8.60324 25.5824 7.59077 21.5826 8.19048C19.5151 8.502 17.3436 9.2315 15.2241 10.3193C13.4011 7.13124 10.7822 5.33992 7.99692 5.51127C5.32608 5.67482 3.05574 7.52327 1.59418 10.7191C0.379687 13.3827 -0.171649 16.8018 0.0468042 20.3429C0.377084 25.7714 2.41858 30.4808 5.3989 32.7108C5.46132 32.7626 5.52634 32.8095 5.59395 32.8563H5.59655C7.0581 33.9568 8.96437 34.5334 11.1827 34.5334C11.8771 34.5334 12.6001 34.4787 13.3516 34.3645C16.8079 33.8479 20.5528 32.1423 23.8894 29.5695C27.2261 26.9942 29.8213 23.8061 31.1971 20.5947C31.9176 18.9098 32.2763 17.2873 32.2763 15.7945C32.2763 13.998 31.7589 12.3806 30.7266 11.0488H30.7187ZM5.19084 19.2473C4.75134 19.9327 4.36126 20.6259 4.02837 21.3242C3.97637 20.9115 3.93995 20.4961 3.91655 20.0677C3.62526 14.7301 5.53934 10.2596 8.18939 10.0805C9.47411 9.99219 10.6964 10.9346 11.6482 12.5312C11.4454 12.6817 11.2451 12.8323 11.0449 12.9855C10.9824 13.0348 10.9174 13.0842 10.855 13.1335C8.54826 14.9456 6.60561 17.051 5.19084 19.2473ZM21.2237 26.1347C16.2721 29.9537 10.6938 31.1195 8.37142 28.9205C8.25179 28.8089 8.13997 28.6868 8.03595 28.5518C7.8825 28.3545 7.75508 28.1442 7.65366 27.9184C7.58603 27.7705 7.52882 27.6223 7.482 27.4666C6.77724 25.1301 8.28821 21.6617 11.3101 18.5542C12.0279 17.8117 12.8289 17.0952 13.7053 16.4202C18.9118 12.4014 24.8152 11.3188 26.8932 14.0032C28.9711 16.685 26.4329 22.1186 21.2237 26.1347Z" fill="url(#paint1_linear_1112_31)" />;
    $[23] = t16;
    $[24] = t17;
    $[25] = t18;
    $[26] = t19;
    $[27] = t20;
    $[28] = t21;
    $[29] = t22;
    $[30] = t23;
    $[31] = t24;
    $[32] = t25;
    $[33] = t26;
    $[34] = t27;
    $[35] = t28;
  } else {
    t16 = $[23];
    t17 = $[24];
    t18 = $[25];
    t19 = $[26];
    t20 = $[27];
    t21 = $[28];
    t22 = $[29];
    t23 = $[30];
    t24 = $[31];
    t25 = $[32];
    t26 = $[33];
    t27 = $[34];
    t28 = $[35];
  }
  let t29;
  if ($[36] !== t15) {
    t29 = <g clipPath="url(#clip0_1112_31)" fill={t15}>{t16}{t17}{t18}{t19}{t20}{t21}{t22}{t23}{t24}{t25}{t26}{t27}{t28}</g>;
    $[36] = t15;
    $[37] = t29;
  } else {
    t29 = $[37];
  }
  let t30;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <linearGradient id="paint0_linear_1112_31" x1="-385.647" y1="130.698" x2="-334.686" y2="-80.0079" gradientUnits="userSpaceOnUse"><stop stopColor="#4E3CED" /><stop offset="1" stopColor="#D978FF" /></linearGradient>;
    $[38] = t30;
  } else {
    t30 = $[38];
  }
  let t31;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <linearGradient id="paint1_linear_1112_31" x1="-1.76843" y1="34.2581" x2="24.1745" y2="8.27" gradientUnits="userSpaceOnUse"><stop stopColor="#4E3CED" /><stop offset="1" stopColor="#D978FF" /></linearGradient>;
    $[39] = t31;
  } else {
    t31 = $[39];
  }
  let t32;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <defs>{t30}{t31}<clipPath id="clip0_1112_31"><rect width="165" height="35" fill="white" /></clipPath></defs>;
    $[40] = t32;
  } else {
    t32 = $[40];
  }
  let t33;
  if ($[41] !== t29) {
    t33 = <svg xmlns="http://www.w3.org/2000/svg" width="165" height="35" viewBox="0 0 165 35" fill="none">{t29}{t32}</svg>;
    $[41] = t29;
    $[42] = t33;
  } else {
    t33 = $[42];
  }
  let t34;
  if ($[43] !== t13 || $[44] !== t14 || $[45] !== t33) {
    t34 = <Link href={t13} className="relative h-8 w-40 shrink-0 mb-[6px]" aria-label="BerryStudio Home" onClick={t14}>{t33}</Link>;
    $[43] = t13;
    $[44] = t14;
    $[45] = t33;
    $[46] = t34;
  } else {
    t34 = $[46];
  }
  const t35 = isDark ? "text-white" : "text-[#0B0623]";
  let t36;
  if ($[47] !== t35) {
    t36 = cn("hidden items-center gap-10 text-sm font-medium md:flex", t35);
    $[47] = t35;
    $[48] = t36;
  } else {
    t36 = $[48];
  }
  let t37;
  if ($[49] !== handleLinkClick || $[50] !== isDark || $[51] !== navLinks || $[52] !== pathname) {
    t37 = navLinks.map(link => <Link key={link.href} href={link.href} onClick={e_1 => handleLinkClick(e_1, link.href)} className={cn("font-sans hover:text-opacity-100 transition-colors", isDark ? "hover:text-white" : "hover:text-[#0B0623]", pathname === link.href && (isDark ? "text-[#7c38f6]" : "text-[#7c38f6]", "text-[#7c38f6] text-sm leading-5 font-medium"))}>{link.name}</Link>);
    $[49] = handleLinkClick;
    $[50] = isDark;
    $[51] = navLinks;
    $[52] = pathname;
    $[53] = t37;
  } else {
    t37 = $[53];
  }
  let t38;
  if ($[54] !== t36 || $[55] !== t37) {
    t38 = <div className={t36}>{t37}</div>;
    $[54] = t36;
    $[55] = t37;
    $[56] = t38;
  } else {
    t38 = $[56];
  }
  let t39;
  if ($[57] !== t34 || $[58] !== t38) {
    t39 = <div className="flex items-center gap-24">{t34}{t38}</div>;
    $[57] = t34;
    $[58] = t38;
    $[59] = t39;
  } else {
    t39 = $[59];
  }
  const t40 = !isDark && "border-black/20 text-[#0B0623] hover:bg-[#0B0623]/5 hover:text-[#0B0623]";
  let t41;
  if ($[60] !== t40) {
    t41 = cn("hidden sm:inline-flex", t40);
    $[60] = t40;
    $[61] = t41;
  } else {
    t41 = $[61];
  }
  const t42 = dict.common.practiceLogin || "Practice Login";
  let t43;
  if ($[62] !== PRACTICE_LOGIN_URL || $[63] !== t41 || $[64] !== t42) {
    t43 = <Button variant="outline" href={PRACTICE_LOGIN_URL} target="_blank" rel="noopener noreferrer" className={t41}>{t42}</Button>;
    $[62] = PRACTICE_LOGIN_URL;
    $[63] = t41;
    $[64] = t42;
    $[65] = t43;
  } else {
    t43 = $[65];
  }
  let t44;
  if ($[66] !== DEMO_LINK || $[67] !== dict.common.bookDemo) {
    t44 = <Button variant="primary" href={DEMO_LINK} target="_blank" rel="noopener noreferrer" className="hidden sm:inline-flex">{dict.common.bookDemo}</Button>;
    $[66] = DEMO_LINK;
    $[67] = dict.common.bookDemo;
    $[68] = t44;
  } else {
    t44 = $[68];
  }
  let t45;
  if ($[69] !== t43 || $[70] !== t44) {
    t45 = <div className="flex items-center gap-4">{t43}{t44}</div>;
    $[69] = t43;
    $[70] = t44;
    $[71] = t45;
  } else {
    t45 = $[71];
  }
  let t46;
  if ($[72] !== dict || $[73] !== isDark || $[74] !== lang || $[75] !== navLinks) {
    t46 = <MobileMenu lang={lang} dict={dict} navLinks={navLinks} isDark={isDark} />;
    $[72] = dict;
    $[73] = isDark;
    $[74] = lang;
    $[75] = navLinks;
    $[76] = t46;
  } else {
    t46 = $[76];
  }
  let t47;
  if ($[77] !== t39 || $[78] !== t45 || $[79] !== t46) {
    t47 = <nav className="mx-auto flex container items-center justify-between px-6 xl:px-0" aria-label="Main Navigation">{t39}{t45}{t46}</nav>;
    $[77] = t39;
    $[78] = t45;
    $[79] = t46;
    $[80] = t47;
  } else {
    t47 = $[80];
  }
  let t48;
  if ($[81] !== t12 || $[82] !== t47) {
    t48 = <header className={t12}>{t47}</header>;
    $[81] = t12;
    $[82] = t47;
    $[83] = t48;
  } else {
    t48 = $[83];
  }
  return t48;
};